import {
  getEffectiveProfileLang,
  getUiLanguageFromProfileLang,
  normalizeProfileLang
} from '../../common/helpers';

export const setLang = (
  dispatch,
  userChurchId = localStorage.getItem('church_id'),
  requestedProfileLang = getEffectiveProfileLang()
) => {
  const profileLanguage = normalizeProfileLang(requestedProfileLang);
  const language = getUiLanguageFromProfileLang(profileLanguage, userChurchId);

  if (profileLanguage) {
    localStorage.setItem('lang', profileLanguage);
  } else {
    localStorage.removeItem('lang');
  }

  dispatch({
    type: 'SET_LANG',
    payload: {
      language,
      profileLanguage,
    }
  })
}
